// → opened product sidebar

import React, { useState, useRef } from "react";
import styled from "styled-components";
import { navigate } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import {
  mainWhite,
  mainBlue,
  mainOrange,
  mainGrey,
  lightGrey,
  siteWidth,
  screen,
  transHover,
} from "../../common/variables";
import Carousel from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import { IoMdClose } from "react-icons/io";
import Spinner from "../../../images/svg/spinner.svg";
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";
import { TouchScrollable } from "react-scrolllock";
import slugify from "slugify";

const Wrapper = styled.div`
  background-color: ${mainWhite};
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  overflow: scroll;
  max-width: ${siteWidth};
  margin: 0 auto;
  transition: ${transHover};

  .sidebar {
    display: flex;

    min-height: 100vh;

    &__bg-colour {
      display: none;
      @media ${screen.xsmall} {
        background-color: ${mainBlue};
        display: block;
        max-width: 470px;
        width: 100%;
      }
    }

    &__product {
      padding-top: 70px;
      padding-bottom: 160px;
      padding-left: 35px;
      padding-right: 35px;
      @media ${screen.xsmall} {
        padding-top: 90px;
        padding-bottom: 220px;
      }
      @media ${screen.small} {
        padding-top: 50px;
        padding-bottom: 50px;
        padding-left: 50px;
        padding-right: 50px;
      }
      @media ${screen.medium} {
        padding-left: 86px;
        padding-right: 86px;
        padding-top: 90px;
        padding-bottom: 90px;
      }
      @media ${screen.large} {
        padding-top: 120px;
        padding-bottom: 120px;
      }
      @media ${screen.xlarge} {
        padding-top: 160px;
        padding-bottom: 160px;
        padding-right: 0;
      }

      .product-info {
        display: flex;
        flex-direction: column;
        @media ${screen.xsmall} {
        }
        @media ${screen.small} {
          flex-direction: row;
        }

        &__title-sm {
          color: ${mainBlue};
          font-size: 1.7rem;
          font-weight: 800;
          @media ${screen.xsmall} {
            font-size: 2.2rem;
          }
          @media ${screen.small} {
            display: none;
          }
        }

        &__gallery {
          margin-top: 16px;
          max-width: ${(props) =>
            props.mobileGalleryWidth
              ? `${props.mobileGalleryWidth}px`
              : `280px`};
          @media ${screen.xsmall} {
            min-width: 720px;
            max-width: 720px;
          }
          @media ${screen.small} {
            min-width: 400px;
            max-width: 400px;
            margin-top: 0;
          }
          @media ${screen.medium} {
            min-width: 480px;
            max-width: 480px;
          }
          @media ${screen.large} {
            min-width: 540px;
            max-width: 540px;
          }

          .BrainhubCarousel {
            width: 100%;
            &__trackContainer {
              width: 100%;
              pointer-events: none;
            }

            &__track {
              .BrainhubCarouselItem {
                .slide-img {
                  width: 100%;
                  max-width: 400px;
                  @media ${screen.small} {
                    max-width: 400px;
                  }
                  @media ${screen.medium} {
                    max-width: 480px;
                  }
                  @media ${screen.large} {
                    max-width: 540px;
                  }
                }
              }
            }

            &__dots {
              justify-content: center;
            }
          }

          .thumbnails {
            position: relative;

            &__list {
              display: flex;
              justify-content: center;

              .thumbnail-img {
                width: 135px;
                background: ${lightGrey};
                border: 1px ${lightGrey} solid;
                margin: 14px 3px;
                cursor: pointer;
                @media ${screen.xsmall} {
                  margin: 24px 10px;
                }

                &--active {
                  border: 1px ${mainBlue} solid;
                }
              }
            }

            &__nav {
              cursor: pointer;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);

              svg {
                font-size: 2.5rem;
                color: ${mainGrey};
                transition: ${transHover};
                &:hover {
                  opacity: 0.8;
                }
              }

              &--prev {
                left: -32px;
                @media ${screen.xsmall} {
                  left: 10px;
                }
                @media ${screen.small} {
                  left: -32px;
                }
                @media ${screen.medium} {
                  left: -24px;
                }
                @media ${screen.large} {
                  left: 0;
                }
              }

              &--next {
                right: -32px;
                @media ${screen.xsmall} {
                  right: 10px;
                }
                @media ${screen.small} {
                  right: -32px;
                }
                @media ${screen.medium} {
                  right: -24px;
                }
                @media ${screen.large} {
                  right: 0;
                }
              }
            }
          }
        }

        &__text {
          width: 100%;
          max-width: 570px;
          @media ${screen.xsmall} {
            min-width: 570px;
          }
          @media ${screen.small} {
            margin-left: 40px;
          }
          @media ${screen.large} {
            min-width: 600px;
            max-width: 600px;
          }
          @media ${screen.xlarge} {
            min-width: 670px;
            max-width: 670px;
          }

          .product-title {
            color: ${mainBlue};
            font-weight: 800;
            display: none;
            @media ${screen.small} {
              font-size: 2rem;
              display: block;
            }
            @media ${screen.medium} {
              font-size: 2.3rem;
            }
            @media ${screen.large} {
              font-size: 2.5rem;
            }
          }

          .product-tabs {
            display: flex;
            margin-top: 45px;
            border-bottom: 2px ${lightGrey} solid;
            @media ${screen.medium} {
              margin-top: 75px;
            }

            &__label {
              color: ${mainBlue};
              cursor: pointer;
              display: block;
              font-size: 1.02rem;
              font-weight: 400;
              padding: 10px 0;
              transition: ${transHover};
              text-align: center;
              width: 50%;
              @media ${screen.xsmall} {
                text-align: left;
                width: inherit;
                font-size: 1.12rem;
                padding: 12px 40px;
              }

              &--selected {
                background-color: ${lightGrey};
                font-weight: 800;
              }
            }
          }

          .product-about {
            color: ${mainBlue};
            margin-top: 16px;
            @media ${screen.xsmall} {
              margin-top: 32px;
            }
            @media ${screen.small} {
              margin-top: 20px;
            }
            @media ${screen.medium} {
              margin-top: 32px;
            }

            p {
              font-size: 0.92rem;
              margin-bottom: 14px;
              @media ${screen.xsmall} {
                font-size: 1rem;
                margin-bottom: 16px;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }

            a {
              color: ${mainOrange};
              @media ${screen.withCursor} {
                &:hover {
                  color: ${mainGrey};
                }
              }
            }
          }

          .product-table {
            display: flex;
            margin-top: 16px;
            @media ${screen.xsmall} {
              margin-top: 32px;
            }
            @media ${screen.small} {
              margin-top: 20px;
            }
            @media ${screen.medium} {
              margin-top: 32px;
            }

            &__column {
              text-align: center;
              flex-grow: 1;
              width: 16.66%;

              .table-heading {
                display: block;
                background-color: ${mainBlue};
                color: ${mainWhite};
                font-size: 0.45rem;
                padding-top: 8px;
                padding-bottom: 8px;
                text-transform: uppercase;
                min-height: ${(props) => (props.isContessi ? "34px" : "0")};
                @media ${screen.xsmall} {
                  font-size: 0.67rem;
                  min-height: ${(props) => (props.isContessi ? "49px" : "0")};
                }
                @media ${screen.small} {
                  font-size: 0.87rem;
                  min-height: ${(props) => (props.isContessi ? "65px" : "0")};
                }
                @media ${screen.large} {
                  min-height: ${(props) => (props.isContessi ? "49px" : "0")};
                }
              }

              .table-subheading {
                display: block;
                background-color: ${lightGrey};
                color: ${mainBlue};
                font-size: 0.35rem;
                display: block;
                padding-top: 6px;
                padding-bottom: 6px;
                text-transform: uppercase;
                min-height: 35px;
                @media ${screen.xsmall} {
                  font-size: 0.55rem;
                  padding-top: 8px;
                  padding-bottom: 8px;
                }
                @media ${screen.small} {
                  font-size: 0.62rem;
                }
                @media ${screen.medium} {
                  min-height: 41px;
                }
              }

              .data-cell {
                display: block;
                font-size: 0.4rem;
                color: ${mainBlue};
                font-weight: 400;
                border-bottom: 2px ${lightGrey} solid;
                width: 100%;
                padding-top: 12px;
                padding-left: 10px;
                padding-right: 10px;
                padding-bottom: 12px;
                @media ${screen.xsmall} {
                  font-size: 0.87rem;
                  padding-top: 20px;
                  padding-bottom: 20px;
                }

                span {
                  display: block;
                  max-width: 130px;
                  margin: 0 auto;
                  min-height: ${(props) =>
                    props.isContessi ? "42px" : "31px"};
                  @media ${screen.xsmall} {
                    min-height: ${(props) =>
                      props.isContessi ? "112px" : "64px"};
                  }
                  @media ${screen.large} {
                    min-height: ${(props) =>
                      props.isContessi ? "96px" : "64px"};
                  }
                }
              }
            }
          }
        }
      }
    }

    &__quote {
      margin-top: 44px;
      position: relative;
      @media ${screen.small} {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
      }
      @media ${screen.medium} {
        margin-top: 88px;
      }
      @media ${screen.large} {
        margin-top: 118px;
      }

      .related-products {
        display: none;
        @media ${screen.small} {
          display: block;
        }
        &__heading {
          color: ${mainBlue};
          font-size: 1.56rem;
          font-weight: 800;
          @media ${screen.small} {
            font-size: 1.4rem;
          }
          @media ${screen.medium} {
            font-size: 1.5rem;
          }
        }

        &__list {
          margin-top: 30px;

          li {
            span {
              cursor: pointer;
              color: ${mainBlue};
              font-size: 2.3rem;
              font-weight: 300;
              display: block;
              margin-bottom: 12px;
              transition: ${transHover};
              @media ${screen.small} {
                font-size: 2.1rem;
              }
              @media ${screen.medium} {
                font-size: 2.3rem;
              }
              @media ${screen.large} {
                font-size: 2.5rem;
              }
              &:hover {
                color: ${mainOrange};
              }
            }
          }
        }
      }

      .dropdown {
        &__heading {
          color: ${mainOrange};
          font-size: 1.3rem;
          font-weight: 800;
          @media ${screen.xsmall} {
            font-size: 1.4rem;
          }
          @media ${screen.small} {
            font-size: 1.4rem;
          }
          @media ${screen.medium} {
            font-size: 1.5rem;
          }
        }

        &__select {
          display: block;
          width: 100%;
          border: 0;
          border-radius: none;
          border-bottom: 1px ${mainBlue} solid;
          padding: 9px 0;
          position: relative;
          margin-top: 15px;
          @media ${screen.small} {
            width: 500px;
          }
          @media ${screen.large} {
            width: 650px;
          }

          select {
            color: ${mainBlue};
            -webkit-appearance: none;
            border: 0;
            font-size: 1.15rem;
            font-weight: 700;
            outline: none;
            cursor: pointer;
            background: none;
            width: 100%;
            @media ${screen.xsmall} {
              font-size: 1.25rem;
            }
          }

          .drop-icon {
            color: ${mainBlue};
            font-size: 2.4rem;
            position: absolute;
            top: calc(50% + 7px);
            transform: translateY(-50%);
            right: 0;
            pointer-events: none;
          }
        }

        &__buttons {
          display: flex;
          flex-direction: column;
          margin-top: 28px;
          position: relative;
          transition: ${transHover};
          @media ${screen.xsmall} {
            flex-direction: row;
            justify-content: flex-end;
            margin-top: 20px;
          }

          .quote-btn {
            background-color: ${mainGrey};
            border: 2px solid ${mainGrey};
            cursor: pointer;
            color: ${mainWhite};
            display: block;
            font-size: 1.02rem;
            padding: 10px 0;
            font-weight: 600;
            text-align: center;
            transition: ${transHover};
            margin-bottom: 15px;
            @media ${screen.xsmall} {
              text-align: left;
              margin-left: 15px;
              padding: 10px 24px;
              font-size: 1.12rem;
            }
            @media ${screen.withCursor} {
              &:hover {
                opacity: 0.8;
              }
            }

            &--add {
              min-width: 188px;
              text-align: center;
            }

            &--view {
              background-color: ${mainWhite};
              color: ${mainGrey};
            }
          }

          .feedback-spinner {
            position: absolute;
            display: block;
            max-width: 58px;
            height: 58px;
            top: 80px;
            left: 50%;
            transform: translateY(-50%) translateX(-50%);
            @media ${screen.xsmall} {
              top: calc(50% - 71px);
              left: 250px;
              max-width: 70px;
              height: 70px;
              transform: translateY(-50%);
            }
            @media ${screen.small} {
              left: 30px;
            }
            @media ${screen.large} {
              top: calc(50% - 71px);
              left: 180px;
            }

            svg {
              width: 100%;
            }
          }
        }
      }

      .feedback-success {
        position: absolute;
        right: 0;
        top: 235px;
        color: ${mainOrange};
        font-size: 1.16rem;
        @media ${screen.xsmall} {
          top: 206px;
          font-size: 1.2rem;
        }
        @media ${screen.small} {
          top: 206px;
        }
      }

      .feedback-error {
        position: absolute;
        right: 0;
        top: 235px;
        color: ${mainOrange};
        font-size: 1.16rem;
        @media ${screen.xsmall} {
          top: 206px;
          font-size: 1.2rem;
        }
        @media ${screen.small} {
          top: 206px;
        }
      }
    }
  }

  .close-btn {
    color: ${mainOrange};
    cursor: pointer;
    font-size: 2.5rem;
    position: absolute;
    top: 22px;
    right: 22px;
    transition: ${transHover};
    @media ${screen.xsmall} {
      top: 45px;
      right: 62px;
    }
    @media ${screen.small} {
      top: 60px;
      right: 60px;
    }
    @media ${screen.withCursor} {
      &:hover {
        color: ${mainGrey};
      }
    }
  }
`;

const ProductSidebar = ({
  isProductSidebarOpen,
  addOrder,
  selectedProduct,
  setProductSidebar,
  setProduct,
  removeUrlSearch,
  addUrlSearch,
  orders,
  productType,
  urlPath,
  products,
  contessi,
}) => {
  // → product information to display
  const {
    id,
    name,
    description,
    images,
    column1Heading,
    column2Heading,
    column3Heading,
    column4Heading,
    column5Heading,
    column6Heading,
    column1Subheading,
    column2Subheading,
    column3Subheading,
    column4Subheading,
    column5Subheading,
    column6Subheading,
    tableRows,
    relatedProducts,
  } = selectedProduct;

  // → return related products id
  const relatedProductsId =
    relatedProducts &&
    relatedProducts.map(
      (item) => item.product.document && item.product.document.id
    );

  // → return filtered related products to be rendered
  const relatedProductList = relatedProductsId
    ? products.filter((item) => {
        return relatedProductsId.some((id) => id === item.node.id);
      })
    : [];

  // → to hide ABOUT table because some products have no about description
  const hasAbout =
    description === "<p></p>"
      ? false
      : description === ""
      ? false
      : description === null
      ? false
      : true;

  // → 2 exemption products to have PRODUCTS label instead of SIZES
  const isNoSizes = name === "Safety Apparel and Accessories";

  // → is user on a search page?
  const isSearchPage =
    typeof window !== "undefined" && window.location.pathname === "/search";

  const productUrl = typeof window !== "undefined" && window.location.href;

  // → get width size for styling gallery
  const mobileGalleryWidth =
    typeof window !== "undefined" && window.innerWidth - 70;

  // → sorted array for product's option dropdown
  const optionList = tableRows && tableRows.map((item) => item.column_1_data);

  // → for toggling ABOUT / SIZES in table
  const [toggleTab, setTab] = useState(false);

  // → user current selected product number
  const [selectedQuote, setSelectQuote] = useState("");

  // → imitating display loading
  const [loader, setLoader] = useState(false);

  // → for resetting select tag index
  const dropdown = useRef(null);

  // → current gallery slide
  const [selectedSlide, setSlide] = useState(0);

  // → gallery slide change handler
  const slideChange = (val) => {
    setSlide(val);
  };

  // → returned div of images to use for main image gallery
  const slides =
    images &&
    images.map((image, i) => (
      <div className="slide-img" key={i} index={i}>
        <GatsbyImage
          image={image.image.gatsbyImageData}
          alt="Product Gallery"
        />
      </div>
    ));

  // → returned div of images to use for thumbnail gallery

  const thumbnails =
    images &&
    images.map((image, i) => (
      <div
        onClick={() => {
          setSlide(i);
        }}
        className={
          selectedSlide === i
            ? `thumbnail-img thumbnail-img--active`
            : `thumbnail-img`
        }
        key={i}
        index={i}
      >
        <GatsbyImage
          image={image.image.gatsbyImageData}
          alt="Product Gallery"
        />
      </div>
    ));

  // → is product already in the cart?
  const isOrderExist = orders.some((order) => order.code === selectedQuote);

  // → show ABOUT tab
  const viewAbout = () => {
    setTab(false);
  };

  // → show SIZES tab
  const viewSize = () => {
    setTab(true);
  };

  // → add to quote handler
  const handleAddToQuote = () => {
    const isOrderExist = orders.some((order) => order.code === selectedQuote);

    if (!isOrderExist) {
      setLoader(true);
      // → timer to imitate loading display
      setTimeout(() => {
        addOrder({
          id: id,
          name: name,
          quantity: "",
          type: productType,
          img: images,
          url: productUrl,
          code: selectedQuote,
        });
        setLoader(false);
      }, 800);
    } else {
      setLoader(true);
      setTimeout(() => {
        setLoader(false);
      }, 800);
    }
  };

  // → sorted columns to use in table from CMS
  const column1Data = tableRows && tableRows.map((data) => data.column_1_data);
  const column2Data = tableRows && tableRows.map((data) => data.column_2_data);
  const column3Data = tableRows && tableRows.map((data) => data.column_3_data);
  const column4Data = tableRows && tableRows.map((data) => data.column_4_data);
  const column5Data = tableRows && tableRows.map((data) => data.column_5_data);
  const column6Data = tableRows && tableRows.map((data) => data.column_6_data);

  // → use to reset selected product if user close the produce sidebar
  const resetProduct = () => {
    setProduct({
      id: id,
      name: "",
      description: "",
      images: null,
    });
    setTab(false);
    setSelectQuote("");
    setProductSidebar(false);
    setSlide(0);
    if (!isSearchPage) {
      removeUrlSearch(urlPath);
    }
  };

  return (
    <TouchScrollable isActive={isProductSidebarOpen}>
      <Wrapper
        style={{
          transform: isProductSidebarOpen
            ? `translateX(0)`
            : `translateX(100%)`,
          opacity: isProductSidebarOpen ? 1 : 0,
        }}
        mobileGalleryWidth={mobileGalleryWidth}
        isContessi={contessi}
      >
        {slides && (
          <div className="sidebar">
            <div className="sidebar__bg-colour"></div>
            <div className="sidebar__product">
              <div className="product-info">
                <h1 className="product-info__title-sm">{name}</h1>

                <div className="product-info__gallery">
                  <Carousel
                    value={selectedSlide}
                    slides={slides}
                    onChange={slideChange}
                  />
                  {thumbnails.length > 1 && (
                    <div className="thumbnails">
                      {selectedSlide !== 0 && (
                        <span
                          className="thumbnails__nav thumbnails__nav--prev"
                          onClick={() => setSlide(selectedSlide - 1)}
                        >
                          <MdKeyboardArrowLeft />
                        </span>
                      )}
                      <div className="thumbnails__list">
                        {thumbnails &&
                          thumbnails.slice(
                            // → only show 3 thumbnail images depending on selectedSlide value
                            slides.length - 1 === selectedSlide
                              ? selectedSlide - 2
                              : selectedSlide !== 0
                              ? selectedSlide - 1
                              : selectedSlide,
                            selectedSlide !== 0
                              ? selectedSlide + 2
                              : selectedSlide + 3
                          )}
                      </div>

                      {selectedSlide !== slides.length - 1 && (
                        <span
                          className="thumbnails__nav thumbnails__nav--next"
                          onClick={() => setSlide(selectedSlide + 1)}
                        >
                          <MdKeyboardArrowRight />
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div className="product-info__text">
                  <h1 className="product-title">{name}</h1>

                  <div className="product-tabs">
                    {hasAbout && (
                      <span
                        className={
                          toggleTab
                            ? `product-tabs__label`
                            : `product-tabs__label product-tabs__label--selected`
                        }
                        onClick={viewAbout}
                      >
                        ABOUT
                      </span>
                    )}

                    <span
                      className={
                        !toggleTab && hasAbout
                          ? `product-tabs__label`
                          : `product-tabs__label product-tabs__label--selected`
                      }
                      onClick={viewSize}
                    >
                      {isNoSizes ? "PRODUCTS" : "SIZES"}
                    </span>
                  </div>
                  {!toggleTab && hasAbout ? (
                    <div className="product-about">
                      <div
                        className="product-about__description"
                        dangerouslySetInnerHTML={{ __html: description }}
                      />
                    </div>
                  ) : (
                    <div className="product-table">
                      {column1Heading && (
                        <div className="product-table__column">
                          <span className="table-heading">
                            {column1Heading}
                          </span>
                          <span className="table-subheading">
                            {column1Subheading ? (
                              column1Subheading
                            ) : (
                              <span style={{ visibility: "hidden" }}>none</span>
                            )}
                          </span>
                          {column1Data &&
                            column1Data.map((data, i) => (
                              <span className="data-cell" key={i}>
                                <span>{data}</span>
                              </span>
                            ))}
                        </div>
                      )}
                      {column2Heading && (
                        <div className="product-table__column">
                          <span className="table-heading">
                            {column2Heading}
                          </span>
                          <span className="table-subheading">
                            {column2Subheading ? (
                              column2Subheading
                            ) : (
                              <span style={{ visibility: "hidden" }}>none</span>
                            )}
                          </span>
                          {column2Data &&
                            column2Data.map((data, i) => (
                              <span className="data-cell" key={i}>
                                <span>{data}</span>
                              </span>
                            ))}
                        </div>
                      )}
                      {column3Heading && (
                        <div className="product-table__column">
                          <span className="table-heading">
                            {column3Heading}
                          </span>
                          <span className="table-subheading">
                            {column3Subheading}
                          </span>
                          {column3Data &&
                            column3Data.map((data, i) => (
                              <span className="data-cell" key={i}>
                                <span>{data}</span>
                              </span>
                            ))}
                        </div>
                      )}
                      {column4Heading && (
                        <div className="product-table__column">
                          <span className="table-heading">
                            {column4Heading}
                          </span>
                          <span className="table-subheading">
                            {column4Subheading}
                          </span>
                          {column4Data &&
                            column4Data.map((data, i) => (
                              <span className="data-cell" key={i}>
                                <span>{data}</span>
                              </span>
                            ))}
                        </div>
                      )}
                      {column5Heading && (
                        <div className="product-table__column">
                          <span className="table-heading">
                            {column5Heading}
                          </span>
                          <span className="table-subheading">
                            {column5Subheading}
                          </span>
                          {column5Data &&
                            column5Data.map((data, i) => (
                              <span className="data-cell" key={i}>
                                <span>{data}</span>
                              </span>
                            ))}
                        </div>
                      )}
                      {column6Heading && (
                        <div className="product-table__column">
                          <span className="table-heading">
                            {column6Heading}
                          </span>
                          <span className="table-subheading">
                            {column6Subheading}
                          </span>
                          {column6Data &&
                            column6Data.map((data, i) => (
                              <span className="data-cell" key={i}>
                                <span>{data}</span>
                              </span>
                            ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="sidebar__quote">
                <div className="related-products">
                  {relatedProductList && (
                    <React.Fragment>
                      {relatedProductList && relatedProductList.length > 0 && (
                        <p className="related-products__heading">
                          Related Products
                        </p>
                      )}

                      <ul className="related-products__list">
                        {relatedProductList.map((product) => (
                          <li key={product.node.id}>
                            <span
                              onClick={() => {
                                dropdown.current.selectedIndex = 0;
                                setTab(false);
                                setSlide(0);
                                setSelectQuote("");
                                setProduct({
                                  id: product.node.id,
                                  name: product.node.data.name.text,
                                  description:
                                    product.node.data.description &&
                                    product.node.data.description.html,
                                  images:
                                    product.node.data.images.length &&
                                    product.node.data.images,
                                  column1Heading:
                                    product.node.data.column_1_heading &&
                                    product.node.data.column_1_heading.text,
                                  column2Heading:
                                    product.node.data.column_2_heading &&
                                    product.node.data.column_2_heading.text,
                                  column3Heading:
                                    product.node.data.column_3_heading &&
                                    product.node.data.column_3_heading.text,
                                  column4Heading:
                                    product.node.data.column_4_heading &&
                                    product.node.data.column_4_heading.text,
                                  column5Heading:
                                    product.node.data.column_5_heading &&
                                    product.node.data.column_5_heading.text,
                                  column6Heading:
                                    product.node.data.column_6_heading &&
                                    product.node.data.column_6_heading.text,
                                  column1Subheading:
                                    product.node.data.column_1_subheading,
                                  column2Subheading:
                                    product.node.data.column_2_subheading,
                                  column3Subheading:
                                    product.node.data.column_3_subheading,
                                  column4Subheading:
                                    product.node.data.column_4_subheading,
                                  column5Subheading:
                                    product.node.data.column_5_subheading,
                                  column6Subheading:
                                    product.node.data.column_6_subheading,
                                  tableRows: product.node.data.rows,
                                  relatedProducts:
                                    product.node.data.product_list,
                                });
                                setProductSidebar(true);
                                addUrlSearch(
                                  urlPath,
                                  slugify(product.node.data.name.text, {
                                    replacement: "-", // → replace spaces with -
                                    lower: true, // → result in lower case
                                  })
                                );
                              }}
                            >
                              {product.node.data.name.text}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </React.Fragment>
                  )}
                </div>
                <div className="dropdown">
                  <p className="dropdown__heading">Ask about</p>
                  {optionList && (
                    <div className="dropdown__select">
                      <select
                        onChange={(e) => {
                          setSelectQuote(e.target.value);
                        }}
                        defaultValue="SELECT"
                        ref={dropdown}
                      >
                        <option disabled value="SELECT">
                          SELECT
                        </option>
                        {optionList.map((item, i) => (
                          <option key={i}>{item}</option>
                        ))}
                      </select>
                      <span className="drop-icon">
                        <MdKeyboardArrowDown />
                      </span>
                    </div>
                  )}

                  <div className="dropdown__buttons">
                    {loader && !isOrderExist && (
                      <span className="feedback-spinner">
                        <Spinner />
                      </span>
                    )}
                    <span
                      className="quote-btn quote-btn--add"
                      onClick={handleAddToQuote}
                      style={{
                        backgroundColor: isOrderExist ? mainOrange : mainGrey,
                        border: isOrderExist
                          ? `2px ${mainOrange} solid`
                          : `2px ${mainGrey} solid`,
                        cursor: isOrderExist ? `not-allowed` : `pointer`,
                        opacity: selectedQuote ? 1 : 0.35,
                        pointerEvents: selectedQuote ? "all" : "none",
                      }}
                    >
                      {isOrderExist ? "ADDED" : "ADD TO QUOTE"}
                    </span>
                    <span
                      className="quote-btn quote-btn--view"
                      onClick={() => {
                        resetProduct();
                        navigate("/enquiry");
                      }}
                    >
                      VIEW QUOTE
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <span className="close-btn" onClick={resetProduct}>
              <IoMdClose />
            </span>
          </div>
        )}
      </Wrapper>
    </TouchScrollable>
  );
};

export default ProductSidebar;
